const formatUnit = (value) => String(Math.max(0, value)).padStart(2, '0');
let countdownTimer;

const updateCountdown = (countdown) => {
  const target = Date.parse(countdown.dataset.target || '');
  if (Number.isNaN(target)) return;

  const remaining = Math.max(0, target - Date.now());
  const days = Math.floor(remaining / 86_400_000);
  const hours = Math.floor((remaining % 86_400_000) / 3_600_000);
  const minutes = Math.floor((remaining % 3_600_000) / 60_000);
  const seconds = Math.floor((remaining % 60_000) / 1_000);

  const values = { days, hours, minutes, seconds };
  Object.entries(values).forEach(([unit, value]) => {
    const node = countdown.querySelector(`[data-countdown-${unit}]`);
    if (node) node.textContent = formatUnit(value);
  });

  if (remaining === 0) {
    countdown.dataset.complete = 'true';
  }
};

const startCountdowns = () => {
  const countdowns = [...document.querySelectorAll('[data-lock-countdown]')];
  if (countdownTimer) window.clearInterval(countdownTimer);
  if (!countdowns.length) return;

  const tick = () => countdowns.forEach(updateCountdown);
  tick();
  countdownTimer = window.setInterval(tick, 1_000);
};

const initRevealObserver = () => {
  const nodes = [...document.querySelectorAll('[data-lock-reveal]:not(.is-visible)')];
  if (!nodes.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    nodes.forEach((node) => node.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  nodes.forEach((node) => observer.observe(node));
};

const focusFormFeedback = () => {
  const feedback = document.querySelector('.lock-form-message[tabindex="-1"]');
  if (feedback instanceof HTMLElement) feedback.focus({ preventScroll: false });
};

const updateTicketVariant = (select, announce = false) => {
  const option = select.selectedOptions[0];
  const form = select.closest('.lock-ticket__form');
  const card = select.closest('.lock-ticket__card');
  if (!option || !form || !card) return;

  const price = card.querySelector('[data-lock-ticket-price]');
  const submit = form.querySelector('[data-lock-ticket-submit]');
  const announcer = form.querySelector('[data-lock-ticket-announcer]');
  const available = option.dataset.available === 'true';

  if (price && option.dataset.price) price.textContent = option.dataset.price;

  if (submit instanceof HTMLButtonElement) {
    submit.disabled = !available;
    submit.textContent = available ? submit.dataset.labelAvailable || 'COMPRAR ENTRADA' : submit.dataset.labelSoldOut || 'AGOTADA';
  }

  if (announce && announcer) {
    const variantName = option.textContent.trim().replace(/\s+/g, ' ');
    announcer.textContent = `${variantName}. ${available ? 'Disponible' : 'Agotada'}.`;
  }
};

const initTicketSelectors = () => {
  document.querySelectorAll('[data-lock-ticket-variant]').forEach((select) => {
    if (!(select instanceof HTMLSelectElement)) return;
    updateTicketVariant(select);

    if (select.dataset.lockInitialized === 'true') return;
    select.dataset.lockInitialized = 'true';
    select.addEventListener('change', () => updateTicketVariant(select, true));
  });
};

// Menú lateral: los enlaces a anclas de la misma página no recargan, así que Horizon
// no cierra el cajón y su bloqueo de scroll (html[scroll-lock]) se queda puesto.
// Cerramos el cajón y desplazamos cuando el scroll ya está liberado.
const initDrawerAnchors = () => {
  if (document.documentElement.dataset.lockDrawerAnchors) return;
  document.documentElement.dataset.lockDrawerAnchors = 'true';

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('header-drawer a[href*="#"]') : null;
    if (!link) return;

    const url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || !url.hash) return;

    const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    const drawer = link.closest('header-drawer');
    if (!target || !drawer) return;

    event.preventDefault();
    if (typeof drawer.close === 'function') drawer.close();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const startedAt = performance.now();
    const scrollWhenUnlocked = () => {
      if (document.documentElement.hasAttribute('scroll-lock') && performance.now() - startedAt < 1200) {
        requestAnimationFrame(scrollWhenUnlocked);
        return;
      }
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      history.pushState(null, '', url.hash);
    };
    requestAnimationFrame(scrollWhenUnlocked);
  });
};

const initLock = () => {
  document.documentElement.classList.add('lock-ready');
  initDrawerAnchors();
  startCountdowns();
  initRevealObserver();
  initTicketSelectors();
  focusFormFeedback();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLock, { once: true });
} else {
  initLock();
}

document.addEventListener('shopify:section:load', initLock);
